// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5098":"eb2b1c53","7976":"a1740768"}[chunkId] + ".chunk.css";
};